import React, { useState, useEffect } from 'react';
import { Input, Select, Space, Typography } from 'antd';

const { TextArea } = Input;
const { Text } = Typography;

const URGENCIES = [
  { value: 'routine', label: 'Routine' },
  { value: 'urgent',  label: 'Urgent' },
  { value: 'stat',    label: 'STAT' },
];

interface Props {
  taskConfig: Record<string, any>;
  onChange: (payload: Record<string, any>, isValid: boolean) => void;
}

const labelStyle: React.CSSProperties = {
  fontSize: 11,
  color: 'var(--mg-text-secondary)',
  display: 'block',
  marginBottom: 2,
};

const CompleteReferralTaskForm: React.FC<Props> = ({ taskConfig, onChange }) => {
  const [form, setForm] = useState({
    specialist_type: taskConfig.specialist_type ?? '',
    specialist_name: '',
    reason:          '',
    urgency:         taskConfig.urgency ?? 'routine',
    notes:           '',
  });

  const update = (patch: Partial<typeof form>) => {
    const next = { ...form, ...patch };
    setForm(next);
    const isValid = !!next.specialist_type && !!next.reason;
    onChange(
      { ...next, specialist_name: next.specialist_name || undefined, notes: next.notes || undefined },
      isValid,
    );
  };

  useEffect(() => {
    const isValid = !!form.specialist_type && !!form.reason;
    onChange(
      { ...form, specialist_name: form.specialist_name || undefined, notes: form.notes || undefined },
      isValid,
    );
  }, []);

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={6}>
      <div>
        <Text style={labelStyle}>
          Specialist Type <span style={{ color: 'var(--mg-error)' }}>*</span>
        </Text>
        <Input
          size="small"
          value={form.specialist_type}
          onChange={(e) => update({ specialist_type: e.target.value })}
          placeholder="e.g. Cardiologist, Dermatologist"
        />
      </div>

      <div>
        <Text style={labelStyle}>Specialist Name</Text>
        <Input
          size="small"
          value={form.specialist_name}
          onChange={(e) => update({ specialist_name: e.target.value })}
          placeholder="Optional — specific specialist's name"
        />
      </div>

      <div>
        <Text style={labelStyle}>
          Reason for Referral <span style={{ color: 'var(--mg-error)' }}>*</span>
        </Text>
        <TextArea
          size="small"
          value={form.reason}
          onChange={(e) => update({ reason: e.target.value })}
          placeholder="Clinical reason for this referral"
          rows={2}
        />
      </div>

      <div>
        <Text style={labelStyle}>Urgency</Text>
        <Select
          size="small"
          value={form.urgency}
          onChange={(v) => update({ urgency: v })}
          options={URGENCIES}
          style={{ width: '100%' }}
        />
      </div>

      <div>
        <Text style={labelStyle}>Additional Notes</Text>
        <TextArea
          size="small"
          value={form.notes}
          onChange={(e) => update({ notes: e.target.value })}
          placeholder="Any additional information for the specialist"
          rows={2}
        />
      </div>
    </Space>
  );
};

export default CompleteReferralTaskForm;
